import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

interface AddLabelPopoverProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  labelKey: string;
  labelValue: string;
  onKeyChange: (v: string) => void;
  onValueChange: (v: string) => void;
  onSubmit: () => void;
  submitting: boolean;
  error: string | null;
}

export default function AddLabelPopover({
  anchorEl,
  onClose,
  labelKey,
  labelValue,
  onKeyChange,
  onValueChange,
  onSubmit,
  submitting,
  error,
}: AddLabelPopoverProps) {
  return (
    <Popover
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <Box sx={{ p: 2, width: 260 }}>
        <Typography variant="subtitle2" sx={{ mb: 1.5 }}>
          Add label
        </Typography>
        <Stack spacing={1.5}>
          <TextField
            label="Key"
            value={labelKey}
            onChange={(e) => onKeyChange(e.target.value)}
            size="small"
            fullWidth
            placeholder="e.g. EmployeeBracket"
          />
          <TextField
            label="Value"
            value={labelValue}
            onChange={(e) => onValueChange(e.target.value)}
            size="small"
            fullWidth
            placeholder="e.g. 5-20"
            onKeyDown={(e) => {
              if (e.key === "Enter") onSubmit();
            }}
          />
          {error && <Alert severity="error">{error}</Alert>}
          <Button
            variant="contained"
            size="small"
            onClick={onSubmit}
            disabled={!labelKey.trim() || !labelValue.trim() || submitting}
          >
            Add
          </Button>
        </Stack>
      </Box>
    </Popover>
  );
}
